import Marquee from "react-fast-marquee";

const words = ["Measure", "Understand", "Personalize", "Deliver"];

export const Ticker = () => (
  <section className="py-14 border-y border-white/10 overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-5xl md:text-7xl px-16 text-foreground/90">
            {w}
          </span>
          <span className="text-primary text-3xl md:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
